import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const state = {
  baseURL: '',
  car: JSON.parse(localStorage.getItem("car")) ? JSON.parse(localStorage.getItem("car")) : '',
  locale: localStorage.getItem('languageSet') ? localStorage.getItem("languageSet") : 'zh',
  curBrand: ''
};

export default new Vuex.Store({
  state,
  getters: { // 监听数据变化的
    getStorage(state) { // 获取本地存储的信息
      if (!state.car) {
        state.car = JSON.parse(localStorage.getItem('car'))
      }
      return state.car
    }
  },
  mutations: {
    $_setCar(state, value) { // 设置存储car
      state.car = value;
      localStorage.setItem('car', JSON.stringify(value))
    },
    $_setLocale(state, value) { // 设置存储locale
      state.locale = value
      localStorage.setItem('languageSet', value)
    },
    $_curBrand(state, value) { // 设置存储curBrand
      state.curBrand = value
    }
  },
  actions: {},
  modules: {}
});


// WEBPACK FOOTER //
// ./src/store/store.js